(function () {
  'use strict';

  function initFilmstrip(root) {
    if (!root || root.dataset.wudyFilmstripInit === 'true') return;
    root.dataset.wudyFilmstripInit = 'true';

    var track = root.querySelector('[data-wudy-filmstrip-track]');
    if (!track) return;

    var row = track.querySelector('.wl-row');
    var frames = row ? Array.prototype.slice.call(row.querySelectorAll('.wl-frame')) : [];
    var progress = root.querySelector('[data-wudy-filmstrip-progress]');
    var counter = root.querySelector('[data-wudy-filmstrip-counter]');
    var prevBtn = root.querySelector('[data-wudy-filmstrip-prev]');
    var nextBtn = root.querySelector('[data-wudy-filmstrip-next]');

    function scrollMax() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function canScroll() {
      return scrollMax() > 2;
    }

    function updateUi() {
      var max = scrollMax();
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (progress) progress.style.transform = 'scaleX(' + ratio + ')';

      if (!frames.length) return;
      var center = track.scrollLeft + track.clientWidth * 0.35;
      var active = 0;
      frames.forEach(function (frame, i) {
        if (frame.offsetLeft <= center) active = i;
      });
      if (counter) {
        counter.textContent =
          String(active + 1).padStart(2, '0') + ' / ' + String(frames.length).padStart(2, '0');
      }
      frames.forEach(function (frame, i) {
        frame.classList.toggle('is-active', i === active);
      });
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 2;
    }

    function scrollByFrame(dir) {
      if (!frames.length) return;
      var gap = 24;
      try {
        var styles = window.getComputedStyle(row);
        gap = parseFloat(styles.columnGap || styles.gap) || 24;
      } catch (err) {}
      var step = frames[0].getBoundingClientRect().width + gap;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    /* Vertical wheel / trackpad → horizontal rail (release at edges) */
    track.addEventListener(
      'wheel',
      function (e) {
        if (!canScroll()) return;
        var dominant = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if (!dominant) return;
        var max = scrollMax();
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= max - 1;
        if ((dominant < 0 && atStart) || (dominant > 0 && atEnd)) return;
        e.preventDefault();
        track.scrollLeft += dominant;
        updateUi();
      },
      { passive: false }
    );

    /* Mouse / touch drag to scroll */
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var moved = false;

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!canScroll()) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startLeft - dx;
      updateUi();
    }

    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);

    /* Don't follow links if user was dragging */
    track.addEventListener(
      'click',
      function (e) {
        if (!moved) return;
        var a = e.target.closest('a, button');
        if (a) {
          e.preventDefault();
          e.stopPropagation();
        }
        moved = false;
      },
      true
    );

    track.addEventListener('scroll', updateUi, { passive: true });
    window.addEventListener('resize', updateUi);

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByFrame(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByFrame(1); });

    updateUi();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wudy-filmstrip]').forEach(initFilmstrip);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (document.readyState !== 'loading') boot();
})();
